export const NORMALIZED_NAMES = {
    APPLICANT: 'APPLICANT',
    ADMIN: 'ADMIN'
};